module.exports = __webpack_public_path__ + "img/work_better4.da1bf497.png";